import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { USER_BILLING_PARAMS } from 'reactApp/appHelpers/configHelpers';
import { aiUpgradeTariff2 } from 'reactApp/appHelpers/featuresHelpers/features/aiUpgrade2';
import { familyUpgradeTariff2 } from 'reactApp/appHelpers/featuresHelpers/features/familyUpgrade2';
import { forWorkUpgradeTariff } from 'reactApp/appHelpers/featuresHelpers/features/forWorkUpgrade';
import { forWorkUpgradeTariff2 } from 'reactApp/appHelpers/featuresHelpers/features/forWorkUpgrade2';
import { upgradeSubscriptionEnabled } from 'reactApp/appHelpers/featuresHelpers/features/upgradeSubscription';
import { voluntarilyBAZPromoEnabled, voluntarilyBAZPromoTariff } from 'reactApp/appHelpers/featuresHelpers/features/voluntarilyBAZ';
import { useFamilyShowFeaturesHook } from 'reactApp/hooks/useFamilyShowHook';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { getUpgradeSubscriptionId } from 'reactApp/modules/billingData/billingData.utils';
import { getFamilyLoadingState } from 'reactApp/modules/family/family.selectors';
import { upgradeSubscriptionPlanRequest } from 'reactApp/modules/upgradeSubscription/upgradeSubscription.module';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { getBazUpdateSubscriptionId } from 'reactApp/ui/VoluntarilyBAZPromo/VoluntarilyBAZPromo.helpers';

import { EnvironmentSelectors } from '../environment/environment';

export const useUpgradeSubscription = () => {
    const dispatch = useDispatch();

    const subscriptions = useSelector(BillingDataSelectors.sortSubscriptionsBySpace);

    const subId = subscriptions[0]?.id;
    const isPhone = EnvironmentSelectors.isMobile();
    const isWeb = subscriptions[0]?.type === 'web';

    const { isLoaded: familyStateIsLoaded } = useSelector(getFamilyLoadingState);
    const isFamily = useFamilyShowFeaturesHook();
    const isBusiness = USER_BILLING_PARAMS.HAS_AI_ASSISTANTS;
    const isPaid = useSelector(UserSelectors.isPaidUser);

    const upgrade2 = forWorkUpgradeTariff2 || aiUpgradeTariff2 || familyUpgradeTariff2;

    useEffect(() => {
        if (upgradeSubscriptionEnabled && subId && isWeb) {
            if (forWorkUpgradeTariff) {
                dispatch(
                    upgradeSubscriptionPlanRequest({
                        sub_id: subId,
                        product_id: forWorkUpgradeTariff,
                        isMobile: isPhone,
                    })
                );
            } else if (upgrade2 && !isFamily && familyStateIsLoaded && !isBusiness && isPaid) {
                const productId = getUpgradeSubscriptionId(subscriptions[0], upgrade2);
                if (productId) {
                    dispatch(
                        upgradeSubscriptionPlanRequest({
                            sub_id: subId,
                            product_id: productId,
                            isMobile: isPhone,
                        })
                    );
                }
            } else if (
                voluntarilyBAZPromoEnabled &&
                !!voluntarilyBAZPromoTariff &&
                !isFamily &&
                familyStateIsLoaded &&
                !isBusiness &&
                isPaid
            ) {
                const productId = getBazUpdateSubscriptionId(subscriptions[subscriptions.length - 1], voluntarilyBAZPromoTariff);
                if (productId) {
                    dispatch(
                        upgradeSubscriptionPlanRequest({
                            sub_id: subId,
                            product_id: productId,
                            isMobile: isPhone,
                        })
                    );
                }
            }
        }
    }, [
        upgradeSubscriptionEnabled,
        subId,
        isFamily,
        familyStateIsLoaded,
        isBusiness,
        isPaid,
        isWeb,
        voluntarilyBAZPromoEnabled,
        forWorkUpgradeTariff,
        forWorkUpgradeTariff2,
        aiUpgradeTariff2,
    ]);
};
